import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users } from 'lucide-react';
import { getCategoryStyle } from './QoreTalksShell';

const LiveRoomCard = ({ room, onJoin }) => {
  const { t } = useTranslation();
  const style = getCategoryStyle(room.category);
  const hostName = room.host?.name || t('qoreTalks.unknown');
  const initial = hostName.charAt(0).toUpperCase();

  return (
    <article className="qt-live-card-v2 qt-motion-item" style={style}>
      <div className="qt-live-card-v2__head">
        <span className="qt-card__badge qt-card__badge--live">
          <span className="qt-nav__dot" aria-hidden /> {t('qoreTalks.liveLabel')}
        </span>
        {room.category && <span className="qt-card__category">{room.category}</span>}
      </div>
      <h3 className="qt-live-card-v2__title">{room.title}</h3>
      <div className="qt-live-card-v2__host">
        <span className="qt-card__host-avatar" aria-hidden>
          {initial}
        </span>
        <div>
          <span className="qt-live-card-v2__host-label">{t('qoreTalks.host')}</span>
          <span className="qt-live-card-v2__host-name">{hostName}</span>
        </div>
        <span className="qt-live-card-v2__count">
          <Users size={14} aria-hidden />
          {room.participantCount || 0}
        </span>
      </div>
      <button type="button" className="qt-btn qt-btn--rose qt-live-card-v2__join" onClick={() => onJoin(room)}>
        {t('qoreTalks.joinRoom')}
      </button>
    </article>
  );
};

export default LiveRoomCard;